import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";

const steps = [
  {
    title: "Small Business Loan",
    description:
      "Fuel your business growth with easy access to funds. Use it for expansion, equipment purchase, hiring, or operational expenses—designed to support businesses at every stage.",
    image: "/operation1.png",
    icon: "/operationLogo1.png",
  },
  {
    title: "Loan Against Property",
    description:
      "Leverage your property’s value to secure a high-value loan at competitive rates. Ideal for businesses needing large capital without disrupting cash flow.",
    image: "/operation2.png",
    icon: "/operationLogo2.png",
  },
  {
    title: "Working Capital Loan",
    description:
      "Maintain smooth business operations with short-term financing options like term loans, lines of credit, and invoice financing—ensuring you never run out of funds when you need them most.",
    image: "/operation3.png",
    icon: "/operationLogo3.png",
  },
];

const ExploreFunding = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          marginTop:"2%",
        }}
      >
        <Box
          sx={{ width: "40px", height: "2px", backgroundColor: "#004AAD" }}
        />
        <Typography variant="h8" sx={{ fontWeight: "bold", color: "#004AAD" }}>
        Business Funding Solutions
        </Typography>
      </Box>
      <Box textAlign="center" marginTop={1}>
        {/* Subtitle */}
        <Typography
          variant="h6"
          sx={{
            mt: 1,
            mb: 2,
            fontWeight: "bold",
            color: "#333333",
            textAlign: "center",
          }}
        >
          Explore Funding Options for Your Business
        </Typography>
      </Box>
    <Box
      sx={{
        maxWidth: "1200px",
        margin: "auto",
        padding: { xs: 2, md: 6 },
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      {steps.map((step, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              md: index % 2 === 0 ? "row" : "row-reverse",
            },
            alignItems: "center",
            gap: -30, // No gap between image and card
          }}
        >
          {/* Image Section */}
          <Box
            component="img"
            src={step.image}
            alt={step.title}
            sx={{
              width: "100%",
              maxWidth: "300px",
              borderRadius: "15px",
              marginRight: "10rem",
              marginLeft: "10rem",
              marginBottom: { xs: "2rem", md: 0 },
            }}
          />
          {/* Card Section */}
          <Card
            sx={{
              flex: 1,
              backgroundColor: "#D5F3EB",
              borderRadius: "12px",
              padding: 1,
              boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
              maxWidth: "400px", // Reduced width
              marginTop: 0, // Ensure no margin at the top
            }}
          >
            <CardContent>
              {/* Icon Inside the Card, Above the Heading */}
              <Box
                component="img"
                src={step.icon}
                alt="Loan Icon"
                sx={{
                  display: "block",
                  marginBottom: "8px", // Added spacing below the icon
                  width: "30px",
                }}
              />

              <Typography
                variant="h7"
                fontWeight="bold"
                color="#333333"
                sx={{ marginBottom: "12px" }}
              >
                {step.title}
              </Typography>

              <Typography
                variant="body2"
                color="#333333"
                sx={{ fontSize: "12px", marginTop: "1rem" }}
              >
                {step.description}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      ))}
    </Box>
          
    </>
  );
};

export default ExploreFunding;
